import React from "react";
import { Link } from "react-router-dom";
import SRILOGO from "../images/SRILOGO.png";
import {
  FaHome,
  FaInfoCircle,
  FaServicestack,
  FaImages,
  FaPhoneAlt,
} from "react-icons/fa";
import "./Navbar.css";

export default function Navbar() {
  return (
    <>
      <nav className="navbar navbar-expand-lg racing-nav shadow-lg">
        <div className="container d-flex align-items-center">

          {/* LOGO + BRAND */}
          <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
            <img src={SRILOGO} alt="SRT Logo" className="srt-logo" />
            <span className="racing-brand">SRI RAJALAKSHMI TRAVELS</span>
          </Link>

          {/* MOBILE TOGGLE */}
          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* MENU LINKS */}
          <div className="collapse navbar-collapse" id="navMenu">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 racing-menu">
              
              <li className="nav-item">
                <Link className="nav-link racing-link" to="/">
                  <FaHome className="me-2" /> Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link racing-link" to="/about">
                  <FaInfoCircle className="me-2" /> About
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link racing-link" to="/services">
                  <FaServicestack className="me-2" /> Services
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link racing-link" to="/gallery">
                  <FaImages className="me-2" /> Gallery
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link racing-link" to="/contact">
                  <FaPhoneAlt className="me-2" /> Contact
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>

      {/* Racing Strip */}
      <div className="racing-strip"></div>
    </>
  );
}
